export enum authInterfaceEnum {
  SIGNIN_SUCCESS = 'SIGNIN_SUCCESS',
  SIGNIN_FAILURE = 'SIGNIN_FAILURE',
  LOGGED_OUT = 'LOGGED_OUT',
  LOGGED_OUT_FAILED = 'LOGGED_OUT_FAILED',
  FETCH_CURRENT_USER_SUCCESS = "FETCH_CURRENT_USER_SUCCESS"
}
